import { IGameRouletteModel } from './interfaces';

export const gameRouletteSelectors = {
    selectData: (state: IGameRouletteModel): IGameRouletteModel['data'] => state.data,
};
